import { fmtPhone } from "./rowUtils";

export function autoCorrectRow(row) {
  let changed = false;
  const next = { ...row };

  const trimFields = [
    "sido",
    "fireStation",
    "safetyCenter",
    "eqp",
    "callsgn",
    "plateNo",
    "name",
    "rdvs",
    "cntct",
    "remark",
  ];
  trimFields.forEach((key) => {
    const v = String(next[key] ?? "").trim();
    if (v !== next[key]) {
      next[key] = v;
      changed = true;
    }
  });

  const sumRaw = String(next.sumnum ?? "").trim();
  if (sumRaw && !/^\d+$/.test(sumRaw)) {
    const digits = sumRaw.replace(/\D/g, "");
    if (digits !== sumRaw) {
      next.sumnum = digits;
      changed = true;
    }
  }

  const formatted = fmtPhone(next.pnum);
  if (formatted && formatted !== next.pnum) {
    next.pnum = formatted;
    changed = true;
  }

  return { row: next, changed };
}

export function autoCorrectRows(rows) {
  let anyChanged = false;
  const corrected = rows.map((row) => {
    const { row: next, changed } = autoCorrectRow(row);
    if (changed) anyChanged = true;
    return next;
  });
  return { rows: corrected, changed: anyChanged };
}
